var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuotes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.864014 11.6552C0.864014 13.8724 2.66133 15.6697 4.87854 15.6697C7.09576 15.6697 8.89307 13.8724 8.89307 11.6552C8.89307 9.46523 7.13877 7.68597 4.95918 7.64277C5.97275 6.64878 7.36091 6.03477 8.89307 6.03477V3.62613C4.45883 3.62613 0.864014 7.22095 0.864014 11.6552ZM18.528 3.62613C14.0938 3.62613 10.499 7.22095 10.499 11.6552C10.499 13.8724 12.2965 15.6697 14.5135 15.6697C16.7307 15.6697 18.528 13.8724 18.528 11.6552C18.528 9.46523 16.7737 7.68597 14.5941 7.64277C15.6077 6.64878 16.996 6.03477 18.528 6.03477V3.62613Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotes);
export default __webpack_public_path__ + "static/media/quotes.01ec2cd3.svg";
export { ForwardRef as ReactComponent };